export const navItems = [
  {
    name: 'Beheer', url: '/manage', privilege: '',
    menuItems: [
      { name: 'Groepen', url: '/userroles', privilege: 'manage' },
      { name: 'Gebruikers', url: '/users', privilege: 'manage' },
      { name: 'Configuratie', url: '/configparams', privilege: 'super' },
      { name: 'Errors', url: '/errorevents', privilege: 'super' },
      { name: 'ApiEvents', url: '/apievents', privilege: 'super' },
      { name: 'CronLogs', url: '/cronlogs', privilege: 'super' },
      { name: 'EmailLogs', url: '/emaillogs', privilege: 'super' },
      { name: 'EmailTemplates', url: '/emails', privilege: 'super' }
    ]
  },
  {
    name: 'TrajectControles', url: '/tc', privilege: '',
    menuItems: [
      { name: 'Types', url: '/sitetypes', privilege: 'manage' },
      { name: 'Rapporten', url: '/reports', privilege: 'inspection_tc|inspection_site' },
      { name: 'Keuringen', url: '/inspections', privilege: 'inspection_tc' }
    ]
  },
  {
    name: 'Historiek', url: '/inspectionevents', privilege: 'manage'
  }
];
